import { Result } from "antd";
import React from "react";
import { ButtonLink } from "../../../misc/button/Button";
import PropTypes from "prop-types";

function PendingResultPayment({ message, onReturn }) {
  return (
    <div className="block-right">
      <div className="info-result-payment">
        <Result
          status="warning"
          title={message || "Votre virement est en attente de traitement."}
        />
        <div className="button-container">
          <ButtonLink to="/tableDeclaration" children="Retour" onClick={onReturn} />
        </div>
      </div>
    </div>
  );
}

PendingResultPayment.propTypes = {
  message: PropTypes.string,
  onReturn: PropTypes.func,
};

export default PendingResultPayment;
